"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fromData = exports.toData = undefined;

var _message = require("./message");

function toData(msg) {

    var str = msg.Body.toString();
    var buffer = Buffer.from(str);
    var len = buffer.length;

    var buf = [];

    buf.push(Math.floor(len / Math.pow(2, 24)) & 0xff);
    buf.push(Math.floor(len / Math.pow(2, 16)) & 0xff);
    buf.push(Math.floor(len / Math.pow(2, 8)) & 0xff);
    buf.push(len & 0xff);

    buf.push(Math.floor(msg.Seq / Math.pow(2, 24)) & 0xff);
    buf.push(Math.floor(msg.Seq / Math.pow(2, 16)) & 0xff);
    buf.push(Math.floor(msg.Seq / Math.pow(2, 8)) & 0xff);

    buf.push(msg.Seq & 0xff);
    buf.push(msg.Cmd);
    buf.push(msg.Version);

    for (var i = 0; i < buffer.length; i++) {
        buf.push(buffer[i]);
    }

    var buff = Buffer.from(buf);

    return buff;
}

function fromData(data) {

    var buffer = Buffer.from(data);

    var header = buffer.slice(0, 10);

    // console.log("header=",header)
    var len = header[0] * Math.pow(2, 24) + header[1] * Math.pow(2, 16) + header[2] * Math.pow(2, 8) + header[3];
    var seq = header[4] * Math.pow(2, 24) + header[5] * Math.pow(2, 16) + header[6] * Math.pow(2, 8) + header[7];
    var cmd = header[8];
    var version = header[9];

    var body = buffer.slice(10).slice(0, len).toString();

    var b = JSON.parse(body);

    if (b == 'undefined') {
        console.log("json parse error :", body);
        return undefined;
    }

    var msg = new _message.Message(cmd, seq, version, JSON.parse(body));
    return msg;
}

exports.toData = toData;
exports.fromData = fromData;
//# sourceMappingURL=protocol.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/im/protocol.js
// module id = Utzo
// module chunks = 0